import PageHero from "../components/site/PageHero";
import { useEffect } from "react";
import { trackVisit } from "../lib/api";

export default function Privacy() {
  useEffect(() => trackVisit("privacy"), []);
  return (
    <div data-testid="privacy-page">
      <PageHero eyebrow="Legale" title="Privacy" titleAccent="Policy." />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6 prose prose-invert text-[var(--text-secondary)] space-y-5">
          <p>La presente informativa è resa ai sensi dell'art. 13 del Regolamento UE 2016/679 (GDPR) per i visitatori del sito di Affari Oro Modena.</p>
          <h2 className="font-serif text-2xl text-white">Titolare del trattamento</h2>
          <p>Affari Oro di Berton Pasqualina — Via Fratelli Rosselli 265, 41125 Modena — P.IVA 03468360361</p>
          <h2 className="font-serif text-2xl text-white">Dati raccolti</h2>
          <p>Raccogliamo i dati che ci fornite tramite i nostri moduli (nome, telefono, messaggio) per rispondere alle vostre richieste tramite chiamata o WhatsApp. Raccogliamo inoltre dati di navigazione anonimi (indirizzo IP, pagine visitate) per finalità statistiche.</p>
          <h2 className="font-serif text-2xl text-white">Finalità del trattamento</h2>
          <p>I dati raccolti tramite il modulo contatti sono utilizzati esclusivamente per rispondere alle richieste e fornire i servizi richiesti.</p>
          <h2 className="font-serif text-2xl text-white">Conservazione dei dati</h2>
          <p>I dati di contatto sono conservati per il tempo necessario a evadere la richiesta e per un periodo massimo di 24 mesi, salvo diversa richiesta dell'interessato.</p>
          <h2 className="font-serif text-2xl text-white">Diritti dell'interessato</h2>
          <p>Avete il diritto di accedere, rettificare o cancellare i vostri dati, di limitarne il trattamento o opporvi allo stesso, e di richiederne la portabilità. Per esercitare tali diritti contattateci al numero +39 338 947 2101 o direttamente in negozio.</p>
          <h2 className="font-serif text-2xl text-white">Sicurezza</h2>
          <p>Adottiamo misure tecniche e organizzative adeguate per proteggere i dati raccolti da accessi non autorizzati, perdita, distruzione o divulgazione.</p>
        </div>
      </section>
    </div>
  );
}
